import { routes as quickSearchRoutes } from "./inventory/routes";
import { routes as stockTransferRoutes } from "./stock-transfer/routes";
import { routes as stockJournalRoutes } from "./inventory-journals/routes";
import { routes as priceAdjustmentRoutes } from "./price-adjustment/routes";
import { routes as stockTakeRoutes } from "./stock-take/routes";
import { routes as approvalsRoutes } from "./transaction-approvals/routes";
import { routes as orderRoutes } from "./orders/routes";
import { routes as stockLevelPerStoreRoutes } from "./stock-level-perstore/routes";
import { routes as stockTransactions } from "./stock-transactions/routes";
import { routes as stockReports } from "./stock-reports/routes";

export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}`,
        name: `${prefix}.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Inventory management Dashboard",
            },
        },
    },
    ...quickSearchRoutes(prefix),
    ...stockTransferRoutes(prefix),
    ...stockJournalRoutes(prefix),
    ...priceAdjustmentRoutes(prefix),
    ...stockTakeRoutes(prefix),
    ...approvalsRoutes(prefix),
    ...orderRoutes(prefix),
    ...stockLevelPerStoreRoutes(prefix),
    ...stockTransactions(prefix),
    ...stockReports(prefix),
];
